export default __webpack_public_path__ + "static/media/13.41d0aaee.jpg";